import SubmissionError from '../../../error/SubmissionError'
import http from '../../../utils/http'
import security from '../../../utils/security'
import {
  CUSTOMER_UPDATE_RESET,
  CUSTOMER_UPDATE_UPDATE_ERROR,
  CUSTOMER_UPDATE_UPDATE_LOADING,
  CUSTOMER_UPDATE_UPDATE_SUCCESS,
  CUSTOMER_UPDATE_RETRIEVE_ERROR,
  CUSTOMER_UPDATE_RETRIEVE_LOADING,
  CUSTOMER_UPDATE_RETRIEVE_SUCCESS,
  CUSTOMER_UPDATE_UPDATE_VIOLATIONS
} from './mutation-types'

const state = {
  loading: false,
  retrieveError: '',
  retrieveLoading: false,
  retrieved: null,
  updated: null,
  updateError: '',
  updateLoading: false,
  violations: null
}

function retrieveError (retrieveError) {
  return {type: CUSTOMER_UPDATE_RETRIEVE_ERROR, retrieveError}
}

function retrieveLoading (retrieveLoading) {
  return {type: CUSTOMER_UPDATE_RETRIEVE_LOADING, retrieveLoading}
}

function retrieveSuccess (retrieved) {
  return {type: CUSTOMER_UPDATE_RETRIEVE_SUCCESS, retrieved}
}

function updateError (updateError) {
  return {type: CUSTOMER_UPDATE_UPDATE_ERROR, updateError}
}

function updateLoading (updateLoading) {
  return {type: CUSTOMER_UPDATE_UPDATE_LOADING, updateLoading}
}

function updateSuccess (updated) {
  return {type: CUSTOMER_UPDATE_UPDATE_SUCCESS, updated}
}

function violations (violations) {
  return {type: CUSTOMER_UPDATE_UPDATE_VIOLATIONS, violations}
}

function reset () {
  return {type: CUSTOMER_UPDATE_RESET}
}

const getters = {
  loading: state => state.loading,
  retrieveError: state => state.retrieveError,
  retrieveLoading: state => state.retrieveLoading,
  retrieved: state => state.retrieved,
  updated: state => state.updated,
  updateError: state => state.updateError,
  updateLoading: state => state.updateLoading,
  violations: state => state.violations
}

const actions = {
  retrieve ({commit}, id) {
    commit(retrieveLoading(true))
    commit(retrieveError(null))
    return http.fetch('/customers/' + id)
      .then(response => response.json())
      .then(data => {
        commit(retrieveLoading(false))
        commit(retrieveSuccess(data))
      })
      .catch(e => {
        commit(retrieveLoading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        commit(retrieveError(e.message))
      })
  },
  update ({commit, state}, {item, values}) {
    commit(updateError(null))
    commit(updateLoading(true))
    commit(violations({}))
    commit(updateSuccess(null))

    return http.fetch(item['@id'], {
        method: 'PUT',
        headers: new Headers({'Content-Type': 'application/ld+json'}),
        body: JSON.stringify(values),
      }
    )
      .then(response => response.json())
      .then(data => {
        commit(updateLoading(false))
        commit(updateSuccess(data))
      })
      .catch(e => {
        commit(updateLoading(false))
        if (security.handleAuthorizationError(e)) {
          return
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors))
          return
        }
        commit(updateError(e.message))
      })
  },
  reset ({commit}) {
    commit(reset())
  }
}

const mutations = {
  [CUSTOMER_UPDATE_RETRIEVE_ERROR] (state, payload) {
    state.retrieveError = payload.retrieveError
  },
  [CUSTOMER_UPDATE_RETRIEVE_LOADING] (state, payload) {
    state.retrieveLoading = payload.retrieveLoading
  },
  [CUSTOMER_UPDATE_RETRIEVE_SUCCESS] (state, payload) {
    state.retrieved = payload.retrieved
  },
  [CUSTOMER_UPDATE_UPDATE_LOADING] (state, payload) {
    state.updateLoading = payload.updateLoading
  },
  [CUSTOMER_UPDATE_UPDATE_ERROR] (state, payload) {
    state.updateError = payload.updateError
  },
  [CUSTOMER_UPDATE_UPDATE_SUCCESS] (state, payload) {
    state.updated = payload.updated
    state.violations = null
  },
  [CUSTOMER_UPDATE_UPDATE_VIOLATIONS] (state, payload) {
    state.violations = payload.violations
  },
  [CUSTOMER_UPDATE_RESET] (state) {
    state.loading = false
    state.retrieveError = ''
    state.retrieveLoading = false
    state.retrieved = null
    state.updated = null
    state.updateError = ''
    state.updateLoading = false
    state.violations = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/customer/update.js